// slices/accountManagement/index.ts

import { combineReducers } from '@reduxjs/toolkit';
import userProfileReducer from './userProfile/slice';
import userIdentificationsReducer from './userIdentifications/slice';

const accountManagementReducer = combineReducers({
  profile: userProfileReducer,
  identifications: userIdentificationsReducer,
});

export default accountManagementReducer;
